import createDOMPurify from 'dompurify'

const purifier = createDOMPurify(window)

const allowedStyleProperties = [
  'color',
  'background-color',
  'font-weight',
  'font-style',
  'font-size',
  'font-family',
  'margin-left',
  'margin-bottom',
  'padding-left',
  'text-decoration',
  'text-align',
]

purifier.addHook('afterSanitizeAttributes', (node) => {
  if (!(node instanceof HTMLElement)) return

  if (node.hasAttribute('style')) {
    const styles = allowedStyleProperties.map((property) => [
      property,
      node.style.getPropertyValue(property),
    ])
    node.removeAttribute('style')
    for (const [property, value] of styles) {
      if (value) node.style.setProperty(property, value)
    }
  }

  if (node instanceof HTMLAnchorElement && node.target === '_blank') {
    node.rel = 'noopener noreferrer'
  }
})

export function sanitizeRichText(html: string): string {
  if (!purifier.isSupported) {
    throw new Error(
      'Rich text sanitization is not supported in this environment',
    )
  }

  return purifier.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'div',
      'span',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'strong',
      'b',
      'em',
      'i',
      'u',
      's',
      'strike',
      'sub',
      'sup',
      'ul',
      'ol',
      'li',
      'a',
      'blockquote',
      'pre',
      'code',
      'mark',
      'hr',
      'img',
      'table',
      'caption',
      'thead',
      'tbody',
      'tfoot',
      'tr',
      'th',
      'td',
    ],
    ALLOWED_ATTR: [
      'href',
      'target',
      'rel',
      'title',
      'class',
      'style',
      'data-list',
      'data-match-index',
      'src',
      'alt',
      'width',
      'height',
      'colspan',
      'rowspan',
      'scope',
      'start',
      'type',
    ],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  })
}
